import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid'
import DownloadIcon from '@mui/icons-material/Download'

const STORAGE_KEY = 'pwa-install-dismissed'
const DISMISS_DURATION_DAYS = 7

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null)
  const [showDialog, setShowDialog] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY)
    if (dismissed) {
      const dismissedAt = Number(dismissed)
      const daysSince = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24)
      if (daysSince < DISMISS_DURATION_DAYS) return
    }

    const handler = (e: Event) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setShowDialog(true)
    }

    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const handleInstall = async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') {
      localStorage.setItem(STORAGE_KEY, String(Date.now()))
    }
    setDeferredPrompt(null)
    setShowDialog(false)
  }

  const handleSkip = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()))
    setDeferredPrompt(null)
    setShowDialog(false)
  }

  if (!showDialog) return null

  return (
    <Dialog
      open={showDialog}
      onClose={handleSkip}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: 2,
              bgcolor: '#f3e5f5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <PhoneAndroidIcon sx={{ color: '#4e148c', fontSize: 24 }} />
          </Box>
          <Typography variant="h5" fontWeight={600}>
            Install Oeta Field
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Install this app on your device for faster access, offline support,
          and a full-screen experience. It takes just a few seconds.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={handleSkip} color="inherit" size="small">
          Not now
        </Button>
        <Button
          onClick={handleInstall}
          variant="contained"
          startIcon={<DownloadIcon />}
          size="small"
        >
          Install App
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default InstallPrompt
